import { styled } from '@mui/material/styles'
import Button from '@mui/material/Button'

export const ButtonMui = styled(Button)({
    color: '#fff',
    textTransform: 'none',

    '&.MuiButton-black': {
        color: '#000',
    },

    '.MuiButton-endIcon': {
        pointerEvents: 'none',
    },
})
